import cx from 'classnames'
import LabelPosition from 'types/LabelPosition'
import React, { useState } from 'react'
import { IProps } from './Interface'
import { FreeText, Select } from 'components'
import { Box, Chip, Modal, Paper, MenuItem, Button, Typography } from '@material-ui/core'
import useStyles from './Styles'

const WordBankCreate: React.FC<IProps> = ({
  color,
  title,
  isTalentTag,
  onAddOwnClick,
  categories,
  shouldRender,
  className,
  ...props
}) => {
  const classes = useStyles({ color })
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState('')
  const [subType, setSubType] = useState(null)

  const handleOpen = () => {
    setOpen(shouldRender())
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleCancel = () => {
    setOpen(false)
    setValue('')
    setSubType(null)
  }

  // tslint:disable-next-line: no-shadowed-variable
  const handleValueChange = (value: any) => {
    setValue(value)
  }

  const handleSubTypeChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setSubType(event.target.value as string)
  }

  const create = () => {
    if ((!isTalentTag && value.trim()) || (isTalentTag && subType && subType.trim() && value.trim())) {
      onAddOwnClick({ value, subType })
      handleCancel()
    }
  }

  return (
    <Box className={cx(classes.root, className)} {...props}>
      <Chip
        className={classes.addButton}
        label={
          <Typography id={'top-5-add-your-own-label'} variant="body1">
            Add your own
          </Typography>
        }
        onClick={handleOpen}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="Add your own"
        aria-describedby="Add your own"
        BackdropProps={{
          className: classes.backdrop
        }}
      >
        <Paper className={classes.content}>
          <Box mb={2} width="100%">
            <FreeText
              id="add-your-own-input"
              label={title}
              alwaysEnabled
              initialValue={value}
              limit={40}
              showLimit={true}
              onChange={handleValueChange}
              labelPosition={LabelPosition.Top}
              classNames={{
                root: classes.freeTextRoot,
                inputContainer: classes.inputContainer,
                labelContainer: classes.labelContainer
              }}
            />
          </Box>
          {isTalentTag && (
            <Box mb={2} width="100%">
              <Select
                fullWidth
                classNames={{ label: classes.selectLabel }}
                value={subType}
                id="select-category-label"
                label="Select Category"
                variant="outlined"
                labelPosition={LabelPosition.Top}
                onChange={handleSubTypeChange}
              >
                {categories.map((category, index) => (
                  <MenuItem key={index} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}
          <Box className={classes.buttonContainer}>
            <Button id="word-bank-cancel-button" variant="contained" onClick={handleCancel}>
              Cancel
            </Button>
            <Button id="word-bank-add-button" variant="contained" onClick={create}>
              Add
            </Button>
          </Box>
        </Paper>
      </Modal>
    </Box>
  )
}

WordBankCreate.defaultProps = {
  title: 'name',
  categories: [],
  isTalentTag: false,
  onAddOwnClick: () => {},
  shouldRender: () => true
}

export default WordBankCreate
